import { normalizeTerm } from "./search-utils";

const LOCAL_SEARCH_HISTORY_KEY = "hotple.localSearchHistory";

export const getLocalSearchHistory = () => {
  if (typeof window === "undefined") return [];
  try {
    const parsed = JSON.parse(
      window.localStorage.getItem(LOCAL_SEARCH_HISTORY_KEY) || "[]"
    );
    return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
  } catch {
    return [];
  }
};

export const clearLocalSearchHistory = () => {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(LOCAL_SEARCH_HISTORY_KEY);
};

export const saveLocalSearchTerm = (value) => {
  const term = normalizeTerm(value);
  if (!term || typeof window === "undefined") return;

  const nextTerms = [
    term,
    ...getLocalSearchHistory().filter(
      (item) => item.toLowerCase() !== term.toLowerCase()
    ),
  ].slice(0, 20);

  window.localStorage.setItem(
    LOCAL_SEARCH_HISTORY_KEY,
    JSON.stringify(nextTerms)
  );
};
